import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';

/*
  Generated class for the ResponsiveProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

// const MOBILE_BREAKPOINT:number = 736;
const MOBILE_BREAKPOINT:number = 600;
const BANNER_BREAKPOINT:number = 400;

@Injectable()
export class ResponsiveProvider {

  constructor(public platform: Platform) {
  }

  isMobile() {
    // console.log("platform width=" + this.platform.width());
    return this.platform.width() <= MOBILE_BREAKPOINT;
  }

  isShowBanner4Mobile() {
    return this.platform.height() > BANNER_BREAKPOINT;
  }

  isMiPad() {
    return this.platform.width() == 960;
  }

}



// WEBPACK FOOTER //
// ./src/providers/responsive/responsive.ts